var success = {
    requestId: 'MSWMOCK-a2355033-bc0f-4dc8-a16f-a856f26f9ccd',
    timestamp: '2024-05-02 15:08:39',
    type: 'SMS_CODE_VERIFY',
    data: {
        loanId: 12345,
        smsId: 1234522,
        signed: true,
        method: 'sms',
    },
};
var errorIncorrectSMSCode = {
    type: 'SMS_CODE_VERIFY',
};
export var loanSignVerifyMock = {
    success: success,
    error: {
        incorrectSMSCode: errorIncorrectSMSCode,
    },
};
